export const Floor1CCC = () => {
  return (
    <>
      <svg
        width="922"
        height="492"
        viewBox="0 0 922 492"
        fill="none"
        style={{ width: '100%', height: 'fit-content', marginBottom: '-5px' }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M757.897 67.2983V1.80664M757.897 67.2983V136.855M757.897 67.2983H825.647M757.897 1.80664H659.885M757.897 1.80664H825.647M9.93666 490.51H51.9417H110.207H219.962M112.013 1.80664H9.03333V328.362M112.013 1.80664V109.303H188.345M112.013 1.80664H214.993M592.135 109.303V1.80664M592.135 109.303V132.79H631.882M592.135 109.303H587.167M592.135 1.80664H659.885M592.135 1.80664H434.955M659.885 132.79V1.80664M659.885 132.79H652.207M659.885 132.79V136.855M757.897 163.052V224.478M757.897 163.052H659.885M757.897 163.052V157.18M592.135 162.148V224.478M592.135 490.51V390.692H633.688V364.043M592.135 490.51H678.855M592.135 490.51H434.955M592.135 224.478H702.342M592.135 224.478V281.388M757.897 224.478H702.342M757.897 224.478V281.388M702.342 224.478V281.388M757.897 281.388H730.119M757.897 281.388V296.745M592.135 281.388V340.105M592.135 281.388H670.273M633.688 322.942V364.043M633.688 364.043H636.85M757.897 322.942V490.51H678.855M757.897 322.942H691.953V329.717M757.897 322.942V317.07M678.855 364.043H691.953V350.042M678.855 364.043V490.51M678.855 364.043H657.175M434.955 170.278V346.428H452.284M9.03333 328.362H110.207M9.03333 328.362V402.887H51.9417H59.62H67.2983M110.207 328.362H174.795L182.022 335.137M110.207 328.362V447.15M219.962 490.51V370.367L214.09 364.947M219.962 490.51H434.955M434.955 490.51V386.331H452.285M214.993 1.80664V109.303M214.993 1.80664H289.518M214.993 109.303H208.67M214.993 109.303H219.51M289.518 1.80664V109.303M289.518 1.80664H363.592M289.518 109.303H239.835M289.518 109.303H337.395M363.592 1.80664V109.303M363.592 1.80664H434.955M363.592 109.303H357.72M363.592 109.303H368.56M434.955 1.80664V109.303M434.955 109.303H388.885M434.955 109.303H566.842M659.885 163.052V157.18M659.885 163.052H620.138M592.135 163.052H599.813M698.277 281.388H705.955M825.647 67.2983V112.013M825.647 67.2983V51.9416M825.647 1.80664H920.948V112.013M825.647 1.80664V31.6166M825.647 229.447V153.567M920.948 229.447V153.567M825.647 112.013V153.567M825.647 112.013H893.848M920.948 112.013V153.567M920.948 112.013H914.173M825.647 153.567H920.948"
          stroke="#788796"
          strokeWidth="1.80667"
        />
        <path
          d="M825.647 160.342H920.948M920.948 160.342V153.567H825.647V166.665M920.948 160.342V166.665M825.647 166.665H920.948M825.647 166.665V173.892M920.948 166.665V173.892M825.647 173.892H920.948M825.647 173.892V180.215M920.948 173.892V180.215M825.647 180.215H920.948M825.647 180.215V187.442M920.948 180.215V187.442M825.647 187.442H920.948M825.647 187.442V193.765M920.948 187.442V193.765M825.647 193.765H920.948M825.647 193.765V200.088M920.948 193.765V200.088M825.647 200.088H920.948M825.647 200.088V207.315M920.948 200.088V207.315M825.647 207.315H920.948M825.647 207.315V213.638M920.948 207.315V213.638M825.647 213.638H920.948M825.647 213.638V220.865M920.948 213.638V220.865M825.647 220.865V227.64H920.948V220.865M825.647 220.865H920.948"
          stroke="#788796"
          strokeWidth="0.903333"
        />
        <path
          d="M51.49 491.413V485.09M51.49 485.09V403.79H59.1683M51.49 485.09H59.1683M59.1683 403.79H66.8467V485.09M59.1683 403.79V485.09M59.1683 485.09H66.8467M66.8467 485.09H106.142"
          stroke="#788796"
          strokeWidth="0.903333"
        />
        <line
          x1="682.017"
          y1="157.654"
          x2="660.337"
          y2="157.654"
          stroke="#788796"
          strokeWidth="0.948686"
        />
        <path
          d="M681.545 157.18C681.545 147.516 673.24 136.403 660.337 136.403"
          stroke="#A1B7CD"
          strokeWidth="0.948686"
        />
        <line
          x1="587.641"
          y1="86.72"
          x2="587.641"
          y2="108.4"
          stroke="#788796"
          strokeWidth="0.948686"
        />
        <path
          d="M587.167 87.1912C577.503 87.1912 566.39 95.4966 566.39 108.4"
          stroke="#A1B7CD"
          strokeWidth="0.948686"
        />
        <line
          x1="599.339"
          y1="185.183"
          x2="599.339"
          y2="163.503"
          stroke="#788796"
          strokeWidth="0.948686"
        />
        <path
          d="M599.813 184.712C609.477 184.712 620.59 176.406 620.59 163.503"
          stroke="#A1B7CD"
          strokeWidth="0.948686"
        />
        <line
          x1="358.194"
          y1="86.72"
          x2="358.194"
          y2="108.4"
          stroke="#788796"
          strokeWidth="0.948686"
        />
        <path
          d="M357.72 87.1912C348.056 87.1912 336.943 95.4966 336.943 108.4"
          stroke="#A1B7CD"
          strokeWidth="0.948686"
        />
        <line
          y1="-0.474343"
          x2="21.68"
          y2="-0.474343"
          transform="matrix(0 1 1 0 368.56 86.72)"
          stroke="#788796"
          strokeWidth="0.948686"
        />
        <path
          d="M368.56 87.1912C378.224 87.1912 389.337 95.4966 389.337 108.4"
          stroke="#A1B7CD"
          strokeWidth="0.948686"
        />
        <line
          x1="209.144"
          y1="86.72"
          x2="209.144"
          y2="108.4"
          stroke="#788796"
          strokeWidth="0.948686"
        />
        <path
          d="M208.67 87.1912C199.006 87.1912 187.893 95.4966 187.893 108.4"
          stroke="#A1B7CD"
          strokeWidth="0.948686"
        />
        <line
          y1="-0.474343"
          x2="21.68"
          y2="-0.474343"
          transform="matrix(0 1 1 0 219.51 86.72)"
          stroke="#788796"
          strokeWidth="0.948686"
        />
        <path
          d="M219.51 87.1912C229.174 87.1912 240.287 95.4966 240.287 108.4"
          stroke="#A1B7CD"
          strokeWidth="0.948686"
        />
        <line
          x1="652.681"
          y1="110.207"
          x2="652.681"
          y2="131.887"
          stroke="#788796"
          strokeWidth="0.948686"
        />
        <path
          d="M652.207 110.678C642.543 110.678 631.43 118.983 631.43 131.886"
          stroke="#A1B7CD"
          strokeWidth="0.948686"
        />
        <line
          y1="-0.474343"
          x2="21.68"
          y2="-0.474343"
          transform="matrix(1 0 0 -1 735.313 317.07)"
          stroke="#788796"
          strokeWidth="0.948686"
        />
        <path
          d="M735.785 317.07C735.785 307.407 744.09 296.293 756.993 296.293"
          stroke="#A1B7CD"
          strokeWidth="0.948686"
        />
        <line
          y1="-0.474343"
          x2="21.68"
          y2="-0.474343"
          transform="matrix(-1 0 0 1 714.085 329.717)"
          stroke="#788796"
          strokeWidth="0.948686"
        />
        <path
          d="M713.614 329.716C713.614 339.38 705.308 350.493 692.405 350.493"
          stroke="#A1B7CD"
          strokeWidth="0.948686"
        />
        <line
          x1="636.376"
          y1="386.626"
          x2="636.376"
          y2="364.946"
          stroke="#788796"
          strokeWidth="0.948686"
        />
        <path
          d="M636.85 386.155C646.513 386.155 657.627 377.85 657.627 364.947"
          stroke="#A1B7CD"
          strokeWidth="0.948686"
        />
        <line
          y1="-0.474343"
          x2="21.68"
          y2="-0.474343"
          transform="matrix(1 0 0 -1 736.217 157.18)"
          stroke="#788796"
          strokeWidth="0.948686"
        />
        <path
          d="M736.688 157.18C736.688 147.516 744.993 136.403 757.897 136.403"
          stroke="#A1B7CD"
          strokeWidth="0.948686"
        />
        <line
          y1="-0.474343"
          x2="21.68"
          y2="-0.474343"
          transform="matrix(-1 0 0 1 848.23 31.6167)"
          stroke="#788796"
          strokeWidth="0.948686"
        />
        <path
          d="M847.759 31.6166C847.759 41.2802 839.453 52.3933 826.55 52.3933"
          stroke="#A1B7CD"
          strokeWidth="0.948686"
        />
        <line
          x1="914.648"
          y1="89.4299"
          x2="914.648"
          y2="111.11"
          stroke="#788796"
          strokeWidth="0.948686"
        />
        <path
          d="M914.173 89.9011C904.51 89.9011 893.397 98.2065 893.397 111.11"
          stroke="#A1B7CD"
          strokeWidth="0.948686"
        />
        <line
          x1="436.795"
          y1="383.816"
          x2="436.795"
          y2="347.917"
          stroke="#788796"
          strokeWidth="0.970247"
        />
        <line
          x1="441.646"
          y1="383.816"
          x2="441.646"
          y2="347.917"
          stroke="#788796"
          strokeWidth="0.970247"
        />
        <line
          x1="446.498"
          y1="383.816"
          x2="446.498"
          y2="347.917"
          stroke="#788796"
          strokeWidth="0.970247"
        />
        <line
          x1="450.378"
          y1="383.816"
          x2="450.378"
          y2="347.917"
          stroke="#788796"
          strokeWidth="0.970247"
        />
        <rect
          x="0.485123"
          y="0.485123"
          width="1.94049"
          height="14.5537"
          transform="matrix(0 1 1 0 436.31 383.816)"
          stroke="#788796"
          strokeWidth="0.970247"
        />
        <rect
          x="0.485123"
          y="0.485123"
          width="1.94049"
          height="14.5537"
          transform="matrix(0 1 1 0 436.31 345.977)"
          stroke="#788796"
          strokeWidth="0.970247"
        />
        <rect
          x="106.593"
          y="447.15"
          width="5.42"
          height="5.42"
          stroke="#788796"
          strokeWidth="1.80667"
        />
        <rect
          x="106.593"
          y="484.187"
          width="5.42"
          height="5.42"
          stroke="#788796"
          strokeWidth="1.80667"
        />
        <rect
          x="109.755"
          y="453.021"
          width="1.80667"
          height="16.26"
          stroke="#788796"
          strokeWidth="0.903333"
        />
        <rect
          x="107.045"
          y="467.475"
          width="1.80667"
          height="16.26"
          stroke="#788796"
          strokeWidth="0.903333"
        />
        <rect
          x="180.136"
          y="337.69"
          width="5.42"
          height="5.42"
          transform="rotate(-47.3566 180.136 337.69)"
          stroke="#788796"
          strokeWidth="1.80667"
        />
        <rect
          x="207.38"
          y="362.78"
          width="5.42"
          height="5.42"
          transform="rotate(-47.3566 207.38 362.78)"
          stroke="#788796"
          strokeWidth="1.80667"
        />
        <rect
          x="186.597"
          y="339.342"
          width="1.80667"
          height="16.26"
          transform="rotate(-47.3566 186.597 339.342)"
          stroke="#788796"
          strokeWidth="0.903333"
        />
        <rect
          x="195.393"
          y="351.127"
          width="1.80667"
          height="16.26"
          transform="rotate(-47.3566 195.393 351.127)"
          stroke="#788796"
          strokeWidth="0.903333"
        />
        <rect
          x="749.767"
          y="322.49"
          width="8.13"
          height="9.03333"
          rx="1.80667"
          fill="url(#paint0_diamond_61_4308)"
        />
        <rect
          x="749.767"
          y="481.477"
          width="8.13"
          height="9.03333"
          rx="1.80667"
          fill="url(#paint1_diamond_61_4308)"
        />
        <rect
          x="592.587"
          y="481.477"
          width="8.13"
          height="9.03333"
          rx="1.80667"
          fill="url(#paint2_diamond_61_4308)"
        />
        <rect
          x="591.683"
          y="1.80664"
          width="8.13"
          height="9.03333"
          rx="1.80667"
          fill="url(#paint3_diamond_61_4308)"
        />
        <rect
          x="749.767"
          y="1.80664"
          width="8.13"
          height="9.03333"
          rx="1.80667"
          fill="url(#paint4_diamond_61_4308)"
        />
        <rect
          x="749.767"
          y="160.793"
          width="8.13"
          height="9.03333"
          rx="1.80667"
          fill="url(#paint5_diamond_61_4308)"
        />
        <rect
          x="589.877"
          y="160.793"
          width="8.13"
          height="9.03333"
          rx="1.80667"
          fill="url(#paint6_diamond_61_4308)"
        />
        <rect
          x="429.987"
          y="1.80664"
          width="8.13"
          height="9.03333"
          rx="1.80667"
          fill="url(#paint7_diamond_61_4308)"
        />
        <rect
          x="269.193"
          y="1.80664"
          width="8.13"
          height="9.03333"
          rx="1.80667"
          fill="url(#paint8_diamond_61_4308)"
        />
        <rect
          x="107.497"
          y="1.80664"
          width="8.13"
          height="9.03333"
          rx="1.80667"
          fill="url(#paint9_diamond_61_4308)"
        />
        <rect
          x="107.497"
          y="161.697"
          width="8.13"
          height="9.03333"
          rx="1.80667"
          fill="url(#paint10_diamond_61_4308)"
        />
        <rect
          x="270.097"
          y="161.697"
          width="8.13"
          height="9.03333"
          rx="1.80667"
          fill="url(#paint11_diamond_61_4308)"
        />
        <rect
          x="283.647"
          y="305.327"
          width="8.13"
          height="9.03333"
          rx="1.80667"
          fill="url(#paint12_diamond_61_4308)"
        />
        <rect
          x="429.987"
          y="161.697"
          width="8.13"
          height="9.03333"
          rx="1.80667"
          fill="url(#paint13_diamond_61_4308)"
        />
        <rect
          x="429.987"
          y="321.587"
          width="8.13"
          height="9.03333"
          rx="1.80667"
          fill="url(#paint14_diamond_61_4308)"
        />
        <rect
          x="270.097"
          y="481.477"
          width="8.13"
          height="9.03333"
          rx="1.80667"
          fill="url(#paint15_diamond_61_4308)"
        />
        <rect
          x="429.987"
          y="481.477"
          width="8.13"
          height="9.03333"
          rx="1.80667"
          fill="url(#paint16_diamond_61_4308)"
        />
        <rect
          x="133.693"
          y="461.603"
          width="7.22667"
          height="7.22667"
          rx="0.903333"
          fill="url(#paint17_diamond_61_4308)"
        />
        <rect
          x="77.6866"
          y="461.603"
          width="7.22667"
          height="7.22667"
          rx="0.903333"
          fill="url(#paint18_diamond_61_4308)"
        />
        <rect
          x="77.6866"
          y="421.857"
          width="7.22667"
          height="7.22667"
          rx="0.903333"
          fill="url(#paint19_diamond_61_4308)"
        />
        <rect
          x="23.4867"
          y="461.603"
          width="7.22667"
          height="7.22667"
          rx="0.903333"
          fill="url(#paint20_diamond_61_4308)"
        />
        <rect
          x="23.4867"
          y="421.857"
          width="7.22667"
          height="7.22667"
          rx="0.903333"
          fill="url(#paint21_diamond_61_4308)"
        />
        <rect
          x="133.693"
          y="414.63"
          width="7.22667"
          height="7.22667"
          rx="0.903333"
          fill="url(#paint22_diamond_61_4308)"
        />
        <path
          d="M873.072 153.567V224.478M873.072 224.478L867.2 218.607M873.072 224.478L878.943 218.607"
          stroke="#788796"
          strokeWidth="0.903333"
        />
        <rect width="8.73222" height="10.6727" rx="1.94049" fill="url(#paint23_diamond_61_4308)" />
        <rect
          y="159.89"
          width="8.73222"
          height="10.6727"
          rx="1.94049"
          fill="url(#paint24_diamond_61_4308)"
        />
        <rect
          x="0.90332"
          y="480.573"
          width="8.73222"
          height="10.6727"
          rx="1.94049"
          fill="url(#paint25_diamond_61_4308)"
        />
        <rect
          y="321.587"
          width="8.73222"
          height="10.6727"
          rx="1.94049"
          fill="url(#paint26_diamond_61_4308)"
        />
        <defs>
          <radialGradient
            id="paint0_diamond_61_4308"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(753.832 327.007) rotate(-91.0912) scale(23.7168 21.3428)"
          >
            <stop stopColor="#A1B7CD" />
            <stop offset="1" stopColor="#0E7EE4" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="paint1_diamond_61_4308"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(753.832 485.993) rotate(-91.0912) scale(23.7168 21.3428)"
          >
            <stop stopColor="#A1B7CD" />
            <stop offset="1" stopColor="#0E7EE4" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="paint2_diamond_61_4308"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(596.652 485.993) rotate(-91.0912) scale(23.7168 21.3428)"
          >
            <stop stopColor="#A1B7CD" />
            <stop offset="1" stopColor="#0E7EE4" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="paint3_diamond_61_4308"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(595.748 6.32331) rotate(-91.0912) scale(23.7168 21.3428)"
          >
            <stop stopColor="#A1B7CD" />
            <stop offset="1" stopColor="#0E7EE4" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="paint4_diamond_61_4308"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(753.832 6.32331) rotate(-91.0912) scale(23.7168 21.3428)"
          >
            <stop stopColor="#A1B7CD" />
            <stop offset="1" stopColor="#0E7EE4" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="paint5_diamond_61_4308"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(753.832 165.31) rotate(-91.0912) scale(23.7168 21.3428)"
          >
            <stop stopColor="#A1B7CD" />
            <stop offset="1" stopColor="#0E7EE4" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="paint6_diamond_61_4308"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(593.942 165.31) rotate(-91.0912) scale(23.7168 21.3428)"
          >
            <stop stopColor="#A1B7CD" />
            <stop offset="1" stopColor="#0E7EE4" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="paint7_diamond_61_4308"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(434.052 6.32331) rotate(-91.0912) scale(23.7168 21.3428)"
          >
            <stop stopColor="#A1B7CD" />
            <stop offset="1" stopColor="#0E7EE4" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="paint8_diamond_61_4308"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(273.258 6.32331) rotate(-91.0912) scale(23.7168 21.3428)"
          >
            <stop stopColor="#A1B7CD" />
            <stop offset="1" stopColor="#0E7EE4" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="paint9_diamond_61_4308"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(111.562 6.32331) rotate(-91.0912) scale(23.7168 21.3428)"
          >
            <stop stopColor="#A1B7CD" />
            <stop offset="1" stopColor="#0E7EE4" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="paint10_diamond_61_4308"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(111.562 166.213) rotate(-91.0912) scale(23.7168 21.3428)"
          >
            <stop stopColor="#A1B7CD" />
            <stop offset="1" stopColor="#0E7EE4" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="paint11_diamond_61_4308"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(274.162 166.213) rotate(-91.0912) scale(23.7168 21.3428)"
          >
            <stop stopColor="#A1B7CD" />
            <stop offset="1" stopColor="#0E7EE4" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="paint12_diamond_61_4308"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(287.712 309.843) rotate(-91.0912) scale(23.7168 21.3428)"
          >
            <stop stopColor="#A1B7CD" />
            <stop offset="1" stopColor="#0E7EE4" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="paint13_diamond_61_4308"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(434.052 166.213) rotate(-91.0912) scale(23.7168 21.3428)"
          >
            <stop stopColor="#A1B7CD" />
            <stop offset="1" stopColor="#0E7EE4" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="paint14_diamond_61_4308"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(434.052 326.103) rotate(-91.0912) scale(23.7168 21.3428)"
          >
            <stop stopColor="#A1B7CD" />
            <stop offset="1" stopColor="#0E7EE4" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="paint15_diamond_61_4308"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(274.162 485.993) rotate(-91.0912) scale(23.7168 21.3428)"
          >
            <stop stopColor="#A1B7CD" />
            <stop offset="1" stopColor="#0E7EE4" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="paint16_diamond_61_4308"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(434.052 485.993) rotate(-91.0912) scale(23.7168 21.3428)"
          >
            <stop stopColor="#A1B7CD" />
            <stop offset="1" stopColor="#0E7EE4" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="paint17_diamond_61_4308"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(137.307 465.216) rotate(-91.2124) scale(18.9742 18.9705)"
          >
            <stop stopColor="#A1B7CD" />
            <stop offset="1" stopColor="#0E7EE4" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="paint18_diamond_61_4308"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(81.3 465.216) rotate(-91.2124) scale(18.9742 18.9705)"
          >
            <stop stopColor="#A1B7CD" />
            <stop offset="1" stopColor="#0E7EE4" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="paint19_diamond_61_4308"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(81.3 425.47) rotate(-91.2124) scale(18.9742 18.9705)"
          >
            <stop stopColor="#A1B7CD" />
            <stop offset="1" stopColor="#0E7EE4" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="paint20_diamond_61_4308"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(27.1 465.216) rotate(-91.2124) scale(18.9742 18.9705)"
          >
            <stop stopColor="#A1B7CD" />
            <stop offset="1" stopColor="#0E7EE4" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="paint21_diamond_61_4308"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(27.1 425.47) rotate(-91.2124) scale(18.9742 18.9705)"
          >
            <stop stopColor="#A1B7CD" />
            <stop offset="1" stopColor="#0E7EE4" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="paint22_diamond_61_4308"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(137.307 418.243) rotate(-91.2124) scale(18.9742 18.9705)"
          >
            <stop stopColor="#A1B7CD" />
            <stop offset="1" stopColor="#0E7EE4" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="paint23_diamond_61_4308"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(4.36611 5.33636) rotate(-90.992) scale(28.0201 22.9244)"
          >
            <stop stopColor="#A1B7CD" />
            <stop offset="1" stopColor="#0E7EE4" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="paint24_diamond_61_4308"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(4.36611 165.226) rotate(-90.992) scale(28.0201 22.9244)"
          >
            <stop stopColor="#A1B7CD" />
            <stop offset="1" stopColor="#0E7EE4" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="paint25_diamond_61_4308"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(5.26943 485.91) rotate(-90.992) scale(28.0201 22.9244)"
          >
            <stop stopColor="#A1B7CD" />
            <stop offset="1" stopColor="#0E7EE4" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="paint26_diamond_61_4308"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(4.36611 326.923) rotate(-90.992) scale(28.0201 22.9244)"
          >
            <stop stopColor="#A1B7CD" />
            <stop offset="1" stopColor="#0E7EE4" stopOpacity="0" />
          </radialGradient>
        </defs>
      </svg>
    </>
  );
};
